import React, {FC, ReactNode} from 'react';
import {AutocompleteRenderGroupParams, createFilterOptions} from '@material-ui/lab';

import Subheader from './Subheader';
import SearchInput from './SearchInput';
import MultipleOption from './MultipleOption';

import {AutocompleteListProps} from './types';
import {Option} from '../../types';

import {StyledAutocomplete, InputContainer} from './AutocompleteList.styles';

const WithoutWrappers: React.FC = ({children}: {children: ReactNode}) => <>{children}</>;

export interface PartialAutocompleteListProps extends Partial<AutocompleteListProps> {
    resultsLabel?: string;
}

const filterOptions = createFilterOptions<Option>({
    matchFrom: 'any',
    ignoreCase: true,
    stringify: option => option.label + option.value
});

const AutocompleteList: FC<PartialAutocompleteListProps> = ({
    options,
    placeholder,
    resultsLabel = 'Results',
    ...props
}: PartialAutocompleteListProps) => {
    const [search, setSearch] = React.useState<string>('');
    const handleSearchChange = (_event, value) => {
        setSearch(value);
    };

    const handleSearchReset = () => {
        setSearch('');
    };

    const optionsList = search
        ? options.map(option => ({
              ...option,
              groupName: resultsLabel
          }))
        : options;

    return (
        <StyledAutocomplete
            open
            multiple
            disableClearable
            clearOnBlur={false}
            getOptionLabel={({value}) => String(value)}
            getOptionSelected={(option, value) => String(option.value) === String(value.value)}
            PopperComponent={WithoutWrappers}
            PaperComponent={WithoutWrappers}
            filterOptions={filterOptions}
            inputValue={search}
            options={optionsList}
            groupBy={option => option.groupName}
            onInputChange={handleSearchChange}
            renderInput={({InputProps, inputProps}) => (
                <InputContainer ref={InputProps.ref}>
                    <SearchInput
                        {...inputProps}
                        search={search}
                        placeholder={placeholder}
                        onReset={handleSearchReset}
                    />
                </InputContainer>
            )}
            renderOption={(option, {selected}) => (
                <MultipleOption key={option.value} selected={selected} {...option} />
            )}
            renderGroup={(params: AutocompleteRenderGroupParams) => [
                params.group ? <Subheader {...params} /> : null,
                params.children
            ]}
            {...props}
        />
    );
};

export default AutocompleteList;
